// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"83":"81c0949a","94":"e1c28520","166":"c9b495c5","238":"b78b47b9","294":"49e8aa0f","385":"5c6e0fcb","453":"8c3e0d99","477":"af858992","722":"bc918f60","769":"cdf15573","806":"8ae73ab8","813":"0b715301","823":"2a4d8e24","877":"b76a66b0"}[chunkId] + ".chunk.js";
};